import React from 'react';
import { IconButton } from '@mui/material';

import { PropsWithChildren } from 'typedActions';
import UserInsightsBlock from 'modules/insights/components/userInsightsBlock';

interface Props extends PropsWithChildren{
    stats: string | number,
    title: string | JSX.Element,
    handleClick: () => void,
}

const UserInsightsBlockInteract = (props: Props) => {
    const [isVisible, setIsVisible] = React.useState(false)

    const showIcon = () => setIsVisible(true)
    const hideIcon = () => setIsVisible(false)

    return (
        <div className="block-container-interact" onMouseOver={showIcon} onMouseLeave={hideIcon}>
            <div className='downloadIcon' style={{float:'right'}}>
                { isVisible &&
                    <IconButton
                    aria-label="download-top-event"
                    aria-haspopup="true"
                    color="primary"
                    onClick={props.handleClick}
                    sx={{maxWidth: "30px", right: "0px", padding: "5px"}}
                    size="small"
                    >
                        {props.children}
                    </IconButton>

                }
            </div>
            <UserInsightsBlock
                stats={props.stats} title={props.title}
            ></UserInsightsBlock>
        </div>
    )
}

export default UserInsightsBlockInteract;